"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ObjectVersion_1 = require("./_ObjectVersion");
exports._ObjectVersionList = {
    type: "list",
    flattened: true,
    member: {
        shape: _ObjectVersion_1._ObjectVersion
    }
};
//# sourceMappingURL=_ObjectVersionList.js.map